import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';

import { isLoggedIn } from './admin-auth';

interface RequireAuthProps {
  children: ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const location = useLocation();
  if (!isLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
